import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { LicenseService } from '../services/license.service';
import { LicenseInfo } from '../models/api/license-info';
import { EcnRoute } from '../models/route';

export const canMatchSap: CanMatchFn = (route: Route | EcnRoute): Observable<boolean | UrlTree> => {
  const licenseService: LicenseService = inject(LicenseService);
  const defaultRedirectPatch: string[] = ['/incidents', 'all', 'incidents'];
  const providedRedirect: string[] = route.data?.redirectTo || null;
  const redirectPath: UrlTree = inject(Router).createUrlTree(providedRedirect || defaultRedirectPatch);

  return licenseService.getLicenseInfo().pipe(
    map((license: LicenseInfo) => license?.hasSapConnectorLicense || redirectPath),
  );
};
